/**
 * Onboarding is complete only after the confirm-step write landed on the
 * user record itself. A leftover `basicUserInfos` node from a failed save
 * must not skip the confirm step.
 */
export function isWelcomeComplete(userData) {
  if (!userData || typeof userData !== 'object') return false;

  const firstName = String(userData.firstName || '').trim();
  const lastName = String(userData.lastName || '').trim();
  const companyName = String(userData.companyName || '').trim();

  return (
    userData.acceptedTerms === true &&
    userData.acceptedCompliance === true &&
    firstName.length > 0 &&
    lastName.length > 0 &&
    companyName.length > 0
  );
}
